<template lang="pug">
.container
  input.input(v-model="keyword", @focus="isFocus = true", @blur="onBlur", @keyup.enter="handleSearch" placeholder="搜索一下，大片立享")
  .btn(@click="handleSearch")
    .iconfont.iconnav_home_seach-copy
    span 搜索
      //- a.navigation(v-for="item in navigation" :href='item.url' :class="{ 'navigation-active' : $route.path === item.url }") {{item.name}}
  .associate(v-show="isFocus")
    .associate-list(v-if="keyword.length && associateList.length")
      .associate-item(v-for="item in associateList" v-html="highlight(item)" :key="item" @click="onSelect(item)")
    .history-wrap(v-else)
      .history-top
        span 搜索历史
        .delete-history(@click="clearHistory")
          .iconfont.iconic_common_delete
          span 清除记录
      .associate-item(v-for="item in historyList" @click="onSelect(item)") {{item}}
</template>

<script>
import { fetchSearchKeyWordLenovo } from '@/api'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'search-input',
  data() {
    return {
      keyword: '',
      isFocus: false,
      isHover: false,
      associateList: [],
      history: ['我对门', '哈哈哈', '1', '拿破仑战争1拿破仑战争1拿破仑战争1拿破仑战争1拿破仑战争1拿破仑战争1']
    }
  },
  computed: {
    isOpacity() {
      let index = this.navigation.map((item) => item.url).indexOf(this.$route?.path)
      return index > -1 ? this.navigation[index].opacity : false
    },
    // ...mapState({
    //   historyList: 'search/historyList'
    // }),
    historyList() {
      return this.$store.state.search.historyList
    }
  },
  watch: {
    keyword(keyword) {
      if (!this.isFocus) return
      this.load(keyword)
    }
  },
  methods: {
    clearHistory() {
      this.removeAll()
    },
    onBlur() {
      if (this.isHover) return
      this.isFocus = false
    },
    onSelect(text) {
      this.isFocus = false
      this.keyword = text
      this.handleSearch()
    },
    handleSearch() {
      this.add(this.keyword)
      if (this.$route.path !== '/search') {
        console.log('push search')
        // this.$router.push(`/search?keyword=${this.keyword}`)
        // this.$router.replace(`/search?keyword=${this.keyword}`)
        window.location.href = `/search?keyword=${this.keyword}`
      } else {
        window.location.href = `/search?keyword=${this.keyword}`
      }
    },
    highlight(item) {
      return item.replace(new RegExp(this.keyword, 'g'), `<span style="color:#CC3648">${this.keyword}</span>`)
    },
    async load(searchKeyWord) {
      try {
        const res = await fetchSearchKeyWordLenovo(searchKeyWord)
        this.associateList = res?.data?.lenovoKeyWords || []
      } catch (e) {
        return []
      }
    },
    goIndex() {
      window.location.href = '/'
    },
    gotoUrl(item) {
      // if (item.url.indexOf('https') > -1) {
      //   alert('即将上线')
      //   return
      // }
      // if (item.url.indexOf('https') > -1) return window.open(item.url)
      if (item.url === this.$route.path) return
      window.open(item.url)
    },
    ...mapMutations({
      add: 'search/add',
      removeAll: 'search/removeAll',
      initHistoryList: 'search/initHistoryList'
    })
  },
  mounted() {
    console.log('搜索框组件里historyList:', this.historyList)
    this.initHistoryList()
    document.querySelector('.associate').addEventListener('mouseenter', () => {
      console.log('enter')
      this.isHover = true
    })
    document.querySelector('.associate').addEventListener('mouseleave', () => {
      console.log('leave')
      this.isHover = false
    })
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">

.container
  display: flex
  width: 360px
  height: 36px
  // background-color: #1D1E21
  // background: rgba(129,134,142,0.30)

  border-radius: 19px
  margin-left: 60px
  margin-right: 49px
  position: relative
  .input
    flex: 1
    // background: #474B52
    background: rgba(129,134,142,0.30)
    border: none
    outline: none
    font-size: 14px
    color: #DEE4E9
    padding: 0 20px
    line-height: 36px
    border: 1px solid #474B52
    border-right: none
    border-radius: 19px 0 0 19px
  .btn
    width: 76px
    background: #CC3648
    border-radius: 0 19px 19px 0
    padding: 0 14px
    display: flex
    justify-content: space-between
    align-items: center
    line-height: 36px
    font-size: 14px
    cursor: pointer
    user-select: none
  .associate
    position: absolute
    width: 350px
    // height: 180px
    background: #1D1E21
    border: 1px solid #202124
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.50)
    border-radius: 4px
    top: calc( 100% +  5px)
    left: 5px

    .associate-list
      padding-top: 12px
      padding-bottom: 12px
    .associate-item
      font-size: 14px
      color:#DEE4E9
      line-height: 30px
      padding: 0 15px
      cursor: pointer
      @include ellipsis
      &:hover
        background: #0F0F0F
  .history-wrap
    padding-top: 12px
    padding-bottom: 12px
    .history-top
      font-size: 14px
      color: #81868E
      margin-bottom: 2px
      padding: 0 15px
      display: flex
      justify-content: space-between
      align-items: center
      line-height: 30px
      .delete-history
        color: #CC3648
        display: flex
        justify-content: space-between
        align-items: center
        cursor: pointer
        user-select: none
        span
          margin-left: 5px
@media screen and (max-width: 1280px)
  .container
    margin-right: 0
  .nav-bar
    padding: 0 10px
</style>
